module.exports = __webpack_public_path__ + "img/pp-06.08fa85b3.jpg";